exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.segment-focus[data-v-bc0cdb18] {\n  background-color: #ecd48a;\n  border: 3px solid #dc6d6d!important;\n}\n.flash-area[data-v-bc0cdb18] {\n  background-color: white; /* デフォルトの背景色 */\n  transition: background-color 0.5s linear; /* 1秒かけて背景色を変化させる */\n}\n.page-block__request[data-v-bc0cdb18] {\n  margin-top: 20px;\n  text-align: center;\n}\n.video-player-control[data-v-bc0cdb18] {\n  margin-right: 20px;\n  padding: 0 0 8px;\n  border: 2px solid #404040;\n  background-color: #ffffff;\n}\n", ""]);

// exports
